module.exports = __webpack_public_path__ + "static/media/login.6920d95a.png";